import * as React from 'react';
import { FunctionComponent } from 'react';
import { Notification } from 'Src/models/notification';
import { Link } from 'react-router-dom';
import {
  getNotificationTypeLabel,
  getNotificationAudience,
  getNotificationAudienceLabel
} from 'Src/helpers/notification/notification';

interface Props {
  notification: Notification;
}

function isLikelyHtml(s: string) {
  return /<\/?(html|head|body)|<!doctype/i.test(s || '');
}

export const SchoolNotificationContent: FunctionComponent<Props> = props => {
  const { notification } = props;

  const typeLabel = getNotificationTypeLabel(notification.type);
  const audience = getNotificationAudience(notification.type);
  const audienceLabel = getNotificationAudienceLabel(audience);

  const title = notification.title || '';
  const body = notification.body || '';

  return (
    <div className="mMarginTop">
      <div className="row">
        <div className="col-md-2 text-secondary">Type:</div>
        <div className="col-md-10">
          {typeLabel}
          <span
            className={`ml-2 badge ${audience === 'ORGANISER' ? 'badge-info' : 'badge-secondary'}`}
            style={{ verticalAlign: 'middle' }}
          >
            {audienceLabel}
          </span>
        </div>

        <div className="col-md-2 text-secondary">Title:</div>
        <div className="col-md-10">{title ? title : <span className="text-muted">-</span>}</div>
      </div>

      <div className="mt-3">
        {notification.type === 'HIGH_LEVEL_TOURNAMENT_AVAILABILITY' && notification.details?.tournamentId && notification.details?.unionId &&
          <Link className="btn btn-primary mb-3" to={notification.details.schoolId === notification.details.unionId
            ? `/highLevelTournaments/participation/schools/availability?tournamentId=${notification.details.tournamentId}`
            : `/tournamentAvailability/respond?tournamentId=${notification.details.tournamentId}&unionId=${notification.details.unionId}`}>Open availability request</Link>}
        {!body ? (
          <div className="text-muted">No content</div>
        ) : isLikelyHtml(body) ? (
          <iframe
            title="Notification content"
            sandbox="allow-same-origin allow-popups"
            srcDoc={body}
            style={{
              width: '100%',
              height: 480,
              border: '1px solid #e5e5e5',
              borderRadius: 6
            }}
          />
        ) : (
          <pre className="m-0" style={{ whiteSpace: 'pre-wrap' }}>
            {body}
          </pre>
        )}
      </div>
    </div>
  );
};
